export default "__VITE_ASSET__D_Oee0Gb__"